import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

export default function NavFeatureCard({
  icon: Icon,
  title,
  description,
  cta,
  borderColor,
  iconBg,
  iconColor,
  onClick
}) {
  return (
    <motion.button
      type="button"
      whileHover={{ y: -6 }}
      onClick={onClick}
      className={`flex flex-col text-left w-full bg-white border border-slate-100 rounded-3xl p-8 shadow-sm cursor-pointer transition-all duration-200 ${borderColor}`}
    >
      <div className={`h-12 w-12 rounded-2xl border flex items-center justify-center mb-6 ${iconBg}`}>
        <Icon className={`h-6 w-6 ${iconColor}`} />
      </div>
      <h3 className="text-xl font-bold text-slate-900 mb-3">{title}</h3>
      <p className="text-slate-500 text-sm leading-relaxed mb-6 flex-1">{description}</p>
      <span
        className="inline-flex items-center gap-1.5 text-sm font-semibold text-slate-900 group-hover:text-slate-700 transition-colors group"
        aria-hidden="true"
      >
        {cta}
        <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
      </span>
    </motion.button>
  );
}
